var map = {
	"./computer/TokenDetail/TokenDetail.vue": [
		"2fd0",
		"chunk-22ae6cda",
		"chunk-bf12f608"
	],
	"./mobile/TokenDetail/TokenDetail.vue": [
		"a878",
		"chunk-22ae6cda",
		"chunk-f5f5fc9a"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "92753";
module.exports = webpackAsyncContext;